module.exports = __webpack_public_path__ + "img/00vacature_graphic-04.2f45fb71.png";